import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  UsersCurrentData,
  UserAnalyticsDataPoint,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { UsersCurrentConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "users-current-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class UsersCurrentChartComponent
  extends BaseChartLogic<UsersCurrentConfig,UsersCurrentData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      UsersCurrentConfig,
      _ngZone
    );
    this.handleDataSubscription(
      this.analyticsService.usersCurrentDataChange
    );
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: UserAnalyticsDataPoint): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
  }

  refreshData(): void {
    this.analyticsService.getTotalCurrentsUsersData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
